module.exports = __webpack_public_path__ + "static/media/icon_3.deb80739.svg";